<div class="page-title">
  <h2>Automations</h2>
</div>
<app-automation [subPage]="'vla'"></app-automation>